/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IAccordion moduleDefinition Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum interactionStyle {
    Independent = 'Independent',
    ExpandOneItemOnly = 'ExpandOneItemOnly'
}

export interface IAccordionConfig {
    heading?: IHeadingData;
    showToggleAll?: boolean;
    interactionStyle?: interactionStyle;
    className?: string;
    clientRender?: boolean;
}

export interface IAccordionResources {
    collapseAllText: string;
    expandAllText: string;
    toggleAllSeparator: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface IAccordionProps<T> extends Msdyn365.IModule<T> {
    resources: IAccordionResources;
    config: IAccordionConfig;
    slots: {
        accordionItems: React.ReactNode[];
    };
}
